/**
 * Avatar e menu de perfil do menu superior (JOR4-7365).
 *
 * Substitui o dxDropDownButton `.menu-usuario`. Comportamento igual: iniciais no
 * avatar, saudação e "Sair".
 */

import { LogOut } from "lucide-react";
import { useCallback, useRef, useState } from "react";

import { usarFecharDropdown } from "../usarFecharDropdown";

export interface PropsMenuUsuario {
    nomeUsuario: string;
    /** Iniciais exibidas no avatar, calculadas por quem hospeda. */
    siglaUsuario: string;
    aoSair: () => void;
}

export const MenuUsuario = ({
    nomeUsuario,
    siglaUsuario,
    aoSair,
}: PropsMenuUsuario) => {
    const [aberto, setAberto] = useState(false);
    const container = useRef<HTMLDivElement>(null);

    const fechar = useCallback(() => setAberto(false), []);

    usarFecharDropdown(aberto, container, fechar);

    return (
        <div className="topbar-ds-usuario" ref={container}>
            <button
                type="button"
                className="topbar-ds-avatar"
                onClick={() => setAberto((atual) => !atual)}
                title={nomeUsuario}
            >
                {siglaUsuario}
            </button>

            {aberto && (
                <div className="topbar-ds-dropdown topbar-ds-dropdown-usuario">
                    <div className="topbar-ds-dropdown-saudacao">
                        Olá, {nomeUsuario}
                    </div>

                    <button
                        type="button"
                        className="topbar-ds-dropdown-item is-clicavel"
                        onClick={() => {
                            setAberto(false);
                            aoSair();
                        }}
                    >
                        <LogOut size={13} />
                        <span>Sair</span>
                    </button>
                </div>
            )}
        </div>
    );
};
